import { TextField } from "@mui/material";
import { useField } from "formik";
import { buildArtFieldLabel } from "./artFieldLabelUtils";
import { useArtFieldMetadata } from "./artFieldMetadataContext";

const FormikTextField = (props) => {
  const [field, meta] = useField(props);
  const fieldMetadata = useArtFieldMetadata(props.name);
  const label = buildArtFieldLabel(props.label, fieldMetadata);
  const hasError =
    Boolean(props.error) || Boolean(meta.touched && meta.error);

  return (
    <TextField
      {...props}
      {...field}
      label={label}
      variant={props.variant ? props.variant : "outlined"}
      onChange={(e) => {
        field.onChange(e); // 1. Actualiza el estado de Formik
        if (props.onChange) {
          props.onChange(e); // 2. Ejecuta tu callback personalizado (onMessageChange)
        }
      }}
      sx={
        {
          width: "100%",
          verticalAlign: "initial",
          ...(props.sx ? props.sx : {}),
          ...(hasError
            ? { "& .MuiFormHelperText-root": { color: "error.main" } }
            : {}),
          ...(props.multiline ? {
            "& .MuiFilledInput-root": {
              alignItems: "flex-start",
              paddingTop: "20px",
            },
            "& textarea": {
              resize: "vertical !important",
              overflow: "auto !important",
              outline: "none",
            },
          } : {}),
        }
      }
      error={hasError}
      helperText={
        props.helperText
          ? props.helperText
          : meta.touched && meta.error
            ? meta.error
            : null
      }
    />
  );
};

export default FormikTextField;
